import * as React from 'react';
import * as ReactDOMClient from 'react-dom/client';
 
globalThis.ReactDOMClient = ReactDOMClient;
globalThis.React = React;
 
const componentsMap = {
    IconWithTitle: React.lazy(() => import('./components/icon-with-title/icon-with-title')),
    Hero: React.lazy(() => import('./components/hero/hero')),
    ComponentA: React.lazy(() => import('./components/component-a')),
    TrustpilotTestimonials: React.lazy(() => import('./components/trustpilot-testimonials/trustpilot-testimonials')),
    SubscriptionContainer: React.lazy(() => import('./components/subscription-container/subscription-container')),
};
 
export default componentsMap;